import { render } from "./Nominee.vue?vue&type=template&id=65449599"
import script from "./Nominee.vue?vue&type=script&lang=js"
export * from "./Nominee.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__